import { Component, ContentChild, ElementRef, Input, OnInit, TemplateRef } from '@angular/core';
import { isString } from 'lodash-es';
import { PageLayoutButtonsTemplateDirective, PageLayoutContentTemplateDirective, PageLayoutTitleTemplateDirective } from '../directives/component.directive';

@Component({
  selector: 'fieldmagic-page-content-layout',
  template: `
    <div
      class="page-content-header row"
      data-testid="page_content_header"
    >
      <div
        class="col-6 fieldmagic-content-title"
        data-testid="content_title"
      >
        <ng-container *ngIf="label | filled">
          <fieldmagic-icon
            *ngIf="icon | filled; else titleFallback"
            [icon]="icon[0]"
            [variant]="icon[1]"
          >
            <ng-container *ngTemplateOutlet="titleFallback"></ng-container>
          </fieldmagic-icon>

          <ng-template #titleFallback>
            <span>{{ label | translate }}</span>
          </ng-template>
        </ng-container>

        <ng-content
          *ngIf="titleTmp | blank"
          select=".page-content-header-title > *"
        ></ng-content>

        <ng-container
          *ngIf="titleTmp | filled"
          [ngTemplateOutlet]="titleTmp"
        >
        </ng-container>
      </div>
      <div
        class="col-6 fieldmagic-page-content-header-actions-container d-flex align-items-center"
        data-testid="page_content_header_actions"
        [class.justify-content-end]="buttonsTmp | filled"
      >
        <ng-content
          *ngIf="buttonsTmp | blank"
          select=".page-content-header-actions > *">
        </ng-content>

        <ng-container
          *ngIf="buttonsTmp | filled"
          [ngTemplateOutlet]="buttonsTmp"
        >
        </ng-container>
      </div>
    </div>
    <hr class="clearfix">
    <div
      class="page-content-body-container w-100"
      data-testid="page_content_body"
    >
      <ng-content
        *ngIf="contentTmp | blank"
        select=".page-content-body > *"
      >
      </ng-content>

      <ng-container
        *ngIf="contentTmp | filled"
        [ngTemplateOutlet]="contentTmp"
      >
      </ng-container>
    </div>
  `,
})
export class PageContentLayoutComponent implements OnInit {
  @Input() label: string;

  /// The icon to display in the header.
  /// If a string is provided, it will be used as the icon name and the icon variant will be set to 'solid'.
  /// If an array is provided, the first element will be used as the icon name and the second element will be used as the icon variant.
  @Input() icon: [string, string] | string;

  @ContentChild(PageLayoutTitleTemplateDirective, {
    read: TemplateRef
  })
  titleTmp?: TemplateRef<ElementRef>;

  @ContentChild(PageLayoutButtonsTemplateDirective, {
    read: TemplateRef
  })
  buttonsTmp?: TemplateRef<ElementRef>;

  @ContentChild(PageLayoutContentTemplateDirective, {
    read: TemplateRef,
  })
  contentTmp?: TemplateRef<ElementRef>;

  ngOnInit(): void {
    if (isString(this.icon)) {
      this.icon = [this.icon, 'solid'];
    }
  }
}
